<template lang="pug">
  div.billing.bank-update
    e-form-modal(
    ref="modalForm"
    @submitModalForm="sendForm()"
    @deleteItem="deleteItem()"
    :hideDeleteButton="(fields.id ? true : false)"
    )
      div(slot="header")
        e-breadcrumbs
        h1.title {{formTitle}}
        e-form-tabs()
      slot
        e-form(:formValidator="formValidator")
          div.body
            div.col
              e-form-group(
              name="name"
              label="Название"
              :model="fields"
              tabView="tab1"
              :required="true"
              )

              e-form-group(
              name="inn"
              inputType="input"
              label="ИНН"
              :model="fields"
              tabView="tab1"
              :required="true"
              )

              e-form-group(
              name="ogrn"
              inputType="input"
              label="ОГРН"
              :model="fields"
              tabView="tab1"
              )

              e-form-group(
                name="address"
                inputType="address"
                label="Адрес"
                :model="fields"
                tabView="tab1"
                addressIdFieldName="address_id"
                :addressData="addressData"
              )

            div.col
              e-form-group(
              name="kpp"
              inputType="input"
              label="КПП"
              :model="fields"
              tabView="tab1"
              )

              e-form-group(
              name="bik"
              inputType="input"
              label="БИК"
              :model="fields"
              tabView="tab1"
              )

              e-form-group(
              name="correspondent_account"
              inputType="input"
              label="Корреспондентский счет банка"
              :model="fields"
              tabView="tab1"
              )

            div.col
</template>

<script>
  import {billing} from "../../api/api-endpoints"
  import formBaseMixin from '../../components/form/form-base-mixin.js'

  export default {
    mixins: [formBaseMixin],
    data () {
      return {
        fields: {
          name: '',
          inn: '',
          kpp: '',
          ogrn: '',
          address_id: '',
          bik: '',
          correspondent_account: ''
        }
      }
    },
    methods: {
      getItemEndpoint (route) {
        if (!route.params.id) {
          return null
        }
        return billing.bank(route.params.id)
      },
      getUpdateOrCreateUrl () {
        return billing.bankUpdateOrCreate(this.$route.params.id)
      },
      getDeleteUrl (fieldId) {
        return billing.bankDelete(fieldId)
      }
    }
  }
</script>
